import $ from 'jquery';

class Sorters {
    constructor (wrapperClass) {
        this.$wrapper     = $(wrapperClass);
        this.wrapperClass = wrapperClass;

        this.$form   = this.$wrapper.find(`${this.wrapperClass}__form`);
        this.$radios = this.$wrapper.find(`${this.wrapperClass}__radio`);

        this.$radios.on('change', $.proxy(this.submitForm, this));
    }

    submitForm () {
        this.$form.submit();
    }
}

export default Sorters;
